import { render, staticRenderFns } from "./appointments-list.vue?vue&type=template&id=109ded9c"
import script from "./appointments-list.vue?vue&type=script&lang=js"
export * from "./appointments-list.vue?vue&type=script&lang=js"
import style0 from "./appointments-list.vue?vue&type=style&index=0&id=109ded9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports